var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#F59E0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 18H5.82031V16.1367H7.0625C8.20703 16.1367 8.98047 15.3789 8.98047 14.2539V14.2461C8.98047 13.1172 8.20703 12.3633 7.0625 12.3633H4.8125V18ZM6.81641 13.1875C7.53906 13.1875 7.96094 13.5742 7.96094 14.25V14.2578C7.96094 14.9336 7.53906 15.3242 6.81641 15.3242H5.82031V13.1875H6.81641ZM10.0938 18H11.1016V16.1367H12.3438C13.4883 16.1367 14.2617 15.3789 14.2617 14.2539V14.2461C14.2617 13.1172 13.4883 12.3633 12.3438 12.3633H10.0938V18ZM12.0977 13.1875C12.8203 13.1875 13.2422 13.5742 13.2422 14.25V14.2578C13.2422 14.9336 12.8203 15.3242 12.0977 15.3242H11.1016V13.1875H12.0977ZM16.7773 18H17.7852V13.2109H19.5234V12.3633H15.043V13.2109H16.7773V18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.83c1b8e774e0cab5fa54899c5022d4f3.svg";
export { ForwardRef as ReactComponent };